import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { JVDate } from "../../../shared/JVDate";
import { JVDropdown } from "../../../shared/JVDropdown";
import { Fetch } from "../../../shared/Fetch";
import { MultiSelect } from "primereact/multiselect";
import { JVDropdownInput } from "../../../shared/JVDropdownInput";
import { JVInput } from "../../../shared/JVInput";

export interface ITenderFilter {
  dateRange?: Date[] | null;
  publishedDateRange?: Date[] | null;
  preProposalMeetingDateRange?: Date[] | null;
  qADateRange?: Date[] | null;
  dueDateRange?: Date[] | null;
  companyId?: number | null;
  branchIds?: number[] | null;
  categoryId?: number | null;
  vendorCompanyId?: number | null;
  assignedTo?: number | null;
  assignedToBM?: number | null;
  status?: string | null;
  added_Today: boolean;
  published_Today: boolean;
  preProposalMeeting_Today: boolean;
  qA_Today: boolean;
  due_Today: boolean;
  rfP_Number?:string|null
}

const EmptyFilter: ITenderFilter = {
  dateRange: null,
  publishedDateRange: null,
  preProposalMeetingDateRange: null,
  qADateRange: null,
  dueDateRange: null,
  companyId: null,
  branchIds: [],
  categoryId: null,
  vendorCompanyId: null,
  assignedTo: null,
  assignedToBM: null,
  status: null,
  added_Today: false,
  published_Today: false,
  preProposalMeeting_Today: false,
  qA_Today: false,
  due_Today: false,
  rfP_Number:""
};

const status_Name = [
  { name: "Draft", value: "Draft", color: "#64748B" },
  { name: "Go", value: "Go", color: "#22C55E" },
  { name: "No Go", value: "No Go", color: "#EF4444" },
  { name: "Uploaded", value: "Uploaded", color: "#3B82F6" },
  { name: "Assigned", value: "Assigned", color: "#8B5CF6" },
  { name: "In Review", value: "In Review", color: "#F59E0B" },
  { name: "Workstream Created", value: "Workstream Created", color: "#06B6D4" },
  { name: "In Progress", value: "In Progress", color: "#F97316" },
  { name: "Completed", value: "Completed", color: "#22C55E" },
];

const statusTemplate = (option: any) => {
  if (!option) return <span>Select Status</span>;

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <i
        className="pi pi-circle-fill"
        style={{
          color: option.color,
          fontSize: "0.6rem",
        }}
      />
      <span>{option.name}</span>
    </div>
  );
};

interface IProps {
  filter: ITenderFilter;
  setFilter: (filter: ITenderFilter) => void;
}

export const Filter = (props: IProps) => {
  const { control, handleSubmit, reset, watch } = useForm<ITenderFilter>({
    defaultValues: props.filter,
  });

  const [categories, setCategories] = useState<any[]>([]);
  const [companies, setCompanies] = useState<any[]>([]);
  const [vendor_Company, setVendor_Company] = useState<Array<any>>();
  const [branches, setBranches] = useState<any[]>([]);
  const [assignedToUsers, setAssignedToUsers] = useState<any[]>([]);
  const [bidassignedToUsers, setBidassignedToUsers] = useState<any[]>([]);
  const [selectedBranch, setSelectedBranch] = useState<number[]>(props.filter.branchIds || []);

  const loadCategories = async () => {
    const response = await Fetch("Tender_Client_Category/GetAllTenderClientCategory", "GET", null, null, null);
    if (response?.ok) {
      const data = await response.json();
      data.unshift({ id: 0, category_Name: "-- SELECT --" });
      setCategories(data);
    }
  };

  const loadCompanies = async () => {
    const response = await Fetch("Dropdown/company", "GET", null, null, null);
    if (response?.ok) {
      const data = await response.json();
      data.unshift({ company_ID: 0, company_Name: "-- SELECT --" });
      setCompanies(data);
    }
  };

  const loadBranches = async (company?: number | null) => {
    const queryParam = company ? `company_id=${company}` : null;
    const response = await Fetch("Dropdown/allBranches", "GET", null, queryParam, null);
    if (response?.ok) {
      const data = await response.json();
      data.unshift({ branch_ID: 0, branchName: "-- SELECT --", company_ID: 0 });
      setBranches(data);
    }
  };

  const loadVendorCompany = async (filter: string | null) => {
    const response = await Fetch(`Tender_POC_Mast/getClientsByCategory`, "GET", null, `filter=${filter}`, null);
    if (response) {
      const data: Array<any> = await response.json();
      const emptyData = {
        vendor_Company_ID: 0,
        vendor_Company_Name: "-- SELECT --",
      };

      data.unshift(emptyData);
      setVendor_Company(data);
    }
  };

  const completeMethodVemdorCompany = (event: { query: string }) => {
    loadVendorCompany(event.query);
  };

  const loadAssignedToUsers = async () => {
    const response = await Fetch("Tender_Mast/GetProposalWriterUser", "GET", null, null, null);
    if (response?.ok) {
      const data = await response.json();
      data.unshift({ login_ID: 0, user_Name: "-- SELECT --" });
      setAssignedToUsers(data);
    } else {
      console.error("Failed to load Proposal Writer Users", response?.status);
    }
  };

  const loadBidAssignedUsers = async () => {
    const response = await Fetch("RPF_Bid_Team_Management/GetBidTeamMembers", "GET", null, null, null);
    if (response?.ok) {
      const data = await response.json();
      data.unshift({ login_ID: 0, user_Name: "-- SELECT --" });
      setBidassignedToUsers(data);
    } else {
      console.error("Failed to load Bid Manager Users", response?.status);
    }
  };

  const onSubmit = (data: any) => {
    props.setFilter({
      ...data,
      fromDate: data.dateRange?.[0] ?? null,
      toDate: data.dateRange?.[1] ?? null,
      vendorCompanyId: data.vendorCompanyId?.vendor_Company_ID ?? null,
      publishedFromDate: data.publishedDateRange?.[0] ?? null,
      publishedToDate: data.publishedDateRange?.[1] ?? null,

      preProposalMeetingFromDate: data.preProposalMeetingDateRange?.[0] ?? null,
      preProposalMeetingToDate: data.preProposalMeetingDateRange?.[1] ?? null,

      qAFromDate: data.qADateRange?.[0] ?? null,
      qAToDate: data.qADateRange?.[1] ?? null,

      dueFromDate: data.dueDateRange?.[0] ?? null,
      dueToDate: data.dueDateRange?.[1] ?? null,
      rfP_Number:data.rfP_Number??null,
      branchIds: selectedBranch,
    });
  };

  useEffect(() => {
    loadCompanies();
    loadCategories();
    loadBranches();
    loadAssignedToUsers();
    loadBidAssignedUsers();
  }, []);

  const company = watch("companyId");

  useEffect(() => {
    if (company) {
      loadBranches(company);
    } else {
      loadBranches();
    }
    setSelectedBranch([]);
  }, [company]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
      <JVDate column={4} label="Date Range" control={control} name="dateRange" selectionMode="range" />
      <JVDate column={4} label="Published Date" control={control} name="publishedDateRange" selectionMode="range" />
      <JVDate column={4} label="Pre Proposal Meeting" control={control} name="preProposalMeetingDateRange" selectionMode="range" />
      <JVDate column={4} label="Q&A Date" control={control} name="qADateRange" selectionMode="range" />
      <JVDate column={4} label="Due Date" control={control} name="dueDateRange" selectionMode="range" />
      <JVDropdown filter column={4} label="Company" control={control} name="companyId" options={companies} optionLabel="company_Name" optionValue="company_ID" />
      <div className="field col-3">
        <label>Branch</label>
        <MultiSelect value={selectedBranch} onChange={(e) => setSelectedBranch(e.value)} options={branches} optionLabel="branchName" optionValue="branch_ID" filter display="chip" placeholder="Select Branch" />
      </div>
      <JVDropdown column={4} label="Category" control={control} name="categoryId" options={categories} optionLabel="category_Name" optionValue="id" />
      <JVInput column={4} label="RFP Number" control={control} name="rfP_Number"/>
      <JVDropdownInput column={4} label="Client Company" completeMethod={completeMethodVemdorCompany} control={control} name="vendorCompanyId" options={vendor_Company} optionLabel="vendor_Company_Name" placeholder="Search Client Company" />
      <JVDropdown filter column={4} label="Bid-Manager" control={control} name="assignedToBM" options={bidassignedToUsers} optionLabel="user_Name" optionValue="login_ID" />
      <JVDropdown filter column={4} label="Proposal Writer" control={control} name="assignedTo" options={assignedToUsers} optionLabel="user_Name" optionValue="login_ID" />
      <JVDropdown column={4} label="RFP Status" control={control} name="status" options={status_Name} optionLabel="name" optionValue="value" itemTemplate={statusTemplate} valueTemplate={statusTemplate} />

      <div className="col-12 flex justify-content-end gap-2">
        <Button label="Search" type="submit" />
        <Button
          type="button"
          label="Clear"
          className="p-button-outlined"
          onClick={() => {
            reset(EmptyFilter);
            setSelectedBranch([]);
            props.setFilter(EmptyFilter);
          }}
        />
      </div>
    </form>
  );
};
